export default __webpack_public_path__ + "static/media/240802.032164f9.jpg";